var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row reports-chart-summary" }, [
    _c(
      "div",
      {
        staticClass: "col",
        class: { "d-sm-flex flex-sm-column": _vm.fullHeight },
      },
      [
        _vm.loaded
          ? [
              _c(
                "div",
                {
                  staticClass: "row",
                  class: { "flex-grow-1": _vm.fullHeight },
                },
                [
                  _c("div", { staticClass: "col-12" }, [
                    _c(
                      "div",
                      {
                        staticClass: "card border-0",
                        class: { "h-100": _vm.fullHeight },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "card-body p-0 chart-wrapper" },
                          [
                            _c("ChartElement", {
                              attrs: {
                                value: _vm.chartData,
                                showFilters: false,
                                isCardStyle: false,
                                allowExport: _vm.chartExport,
                                notDataMsg: _vm.notFoundMsg,
                                alignTools: "left",
                                classTitle: "subtitle",
                              },
                              on: { tool: _vm.onTool },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]),
                ]
              ),
            ]
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }